import { createRouter, createWebHistory } from "vue-router"
import Home from "../views/Home.vue"
import Fallback from "../views/Fallback.vue"

const routes = [
  {
    path: "/3rgf8u3gfuyghsdkhfk2:catchAll(.*)",
    component: Fallback
  },
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
